// extracted by mini-css-extract-plugin
module.exports = {"squareWrap":"CurrentTurn_squareWrap_2LHNI","faTimes":"CurrentTurn_faTimes_19EMR","faCircle":"CurrentTurn_faCircle_1TRjw"};